import { useEffect } from 'react';

const ChatSound = ({ play, audioSrc }) => {
  useEffect(() => {
    let audioContext;
    let source;
    let isActive = true;

    // Only play sound when the component is shown and a source is provided
    if (play && audioSrc) {
      audioContext = new (window.AudioContext || window.webkitAudioContext)();

      // Fetch and decode the chosen audio
      fetch(audioSrc)
        .then((res) => res.arrayBuffer())
        .then((buf) => audioContext.decodeAudioData(buf))
        .then((decoded) => {
          if (!isActive) return;
          source = audioContext.createBufferSource();
          source.buffer = decoded;
          source.connect(audioContext.destination);
          source.start(0);
        })
        .catch((err) => console.error('Audio error:', err));
    }

    // Cleanup: stop any playing audio and close the AudioContext
    return () => {
      isActive = false;
      if (source) {
        source.stop();
        source.disconnect();
      }
      if (audioContext) {
        audioContext.close();
      }
    };
  }, [play, audioSrc]); // reruns when show or audioSrc change

  return null;
};

export default ChatSound;
